import React, { useEffect } from 'react';

import { useCheckCard } from '@vlabs/api/point-api/client';
import { CardPageFilterMenu, CardPageFiltersProvider } from '@vlabs/monokit/entities/card/filters';
import type { TGetCardFacesParams } from '@vlabs/monokit/entities/card/filters/types';
import { useCardIdFromLocation } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { PageFilters } from '@vlabs/monokit/shared/ui/page/PageFilters';
import { Pages } from '@vlabs/uikit';

import { CardPageContent } from './card-page-content';
import st from './CardPage.module.sass';

const defaultFiltersValue: TGetCardFacesParams = {
  page: 0,
  page_size: 25,
};

export function CardPage(): React.ReactNode {
  const cardId = useCardIdFromLocation();
  const checkCard = useCheckCard({
    mutation: {
      retry: false,
    },
  });

  useEffect(() => {
    checkCard.mutate({ cardId });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checkCard.isPending) return null;
  if (checkCard.isError) return <Pages.NotFoundPage />;

  return (
    <Page>
      <CardPageFiltersProvider initialData={defaultFiltersValue}>
        <FilterMenuProvider>
          <PageContent className={st.PageContent}>
            <CardPageContent />
          </PageContent>

          <PageFilters>
            <CardPageFilterMenu />
          </PageFilters>
        </FilterMenuProvider>
      </CardPageFiltersProvider>
    </Page>
  );
}
